


















import { Vue, Component } from 'vue-property-decorator'
import LogoButton from 'src/components/presenter/layout/LogoButton.vue'
import ProfileSwitcher from 'components/account/ProfileSwitcher.vue'

@Component({
  components: {
    LogoButton,
    ProfileSwitcher
  }
})
export default class LayoutsAccount extends Vue {
  top = true
}
